import React, { useMemo } from 'react';
import styles from './SkillPaths.module.scss';
import { Doughnut } from 'react-chartjs-2';
import { Grid } from '@material-ui/core';
const options = (total) => ({
  plugins: {
    tooltip: {
      enabled: total > 0,
      callbacks: {
        label: function (context) {
          return ` ${context?.label}: ${context?.formattedValue}%`;
        },
      },
    },
    legend: {
      display: false,
    },
  },
  animation: {
    duration: 1,
  },
  maintainAspectRatio: false,
  cutout: '70%',
  radius: '100%',
  cutoutPercentage: 10,
});
const TotalUsersChart = ({ title = '', users = {} }) => {
  const data = useMemo(() => {
    const fetchChartData = (users) => {
      if (users?.total_users) {
        return [
          users?.percentage_completed,
          users?.percentage_in_progress,
          users?.percentage_not_started,
        ];
      } else {
        return [1];
      }
    };

    const colors = users?.total_users === 0 ? ['#e3e3e3'] : ['#63D2AB', '#F8D783', '#ECEFF1'];

    return {
      labels: ['Completed', 'In Progress', 'Not started'],
      datasets: [
        {
          label: '',
          data: fetchChartData(users),
          backgroundColor: colors,
          borderColor: colors,
          hoverBorderColor: colors,
          hoverBackgroundColor: colors,
          hoverBorderWidth: 0,
          hoverBorderRadius: 0,
          hoverOffset: 6,
          borderWidth: 1,
        },
      ],
    };
  }, [users]);
  return (
    <div className={styles.progressChart}>
      <div className={styles.cardHeader}>
        <div className={styles.cardHeaderLine1}>
          <span className={styles.headerPeriod}>Progress</span>
          <span className={styles.headerPeriod}>In the last year</span>
        </div>
        <span className={styles.headerTitle}>{title}</span>
      </div>
      <div className={styles.bodyChart}>
        <Grid container direction="row" spacing={1} alignItems="center" justifyContent="center">
          <Grid item md={6} className={styles.chartDatasets}>
            <ul className="listUnstyled">
              <li className={styles.completed}>
                Completed - <strong>{users?.total_usesrs_completed}</strong>
              </li>
              <li className={styles.inProgress}>
                In Progress - <strong>{users?.total_usesrs_in_progress}</strong>
              </li>
              <li className={styles.yetToStart}>
                Not Started - <strong>{users?.total_usesrs_not_started}</strong>
              </li>
            </ul>
          </Grid>
          <Grid item md={6} style={{ height: '200px', position: 'relative', marginTop: '1.5rem' }}>
            <div className={styles.totalContainer}>
              <h6 className="heading1">{users?.total_users}</h6>
              <p className="paragraph">Total</p>
              <p className="paragraph">Users</p>
            </div>
            <Doughnut data={data} options={options(users?.total_users)} />
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default TotalUsersChart;
